// extracted by mini-css-extract-plugin
export default {"image":"header-logo_image__y2wQj","link":"header-logo_link__IYC1V"};